import { Flex, SegmentedControl, Text } from '@radix-ui/themes';
import React from 'react';
import { useHistory } from 'react-router-dom';
import useAuthentication from '~/hooks/use-authentication';

const MENU_ITEMS = [
  { value: 'organizations', label: 'Organizations' },
  { value: 'pricelists', label: 'Pricelists' },
  { value: 'network-service', label: 'Network Service' },
  { value: 'countries-service', label: 'Countries Service' },
];

const ELEVATED_USERS_MENU_ITEM = { value: 'elevated-users', label: 'Elevated Users' };

function Menu() {
  const { canManageElevatedPermissions } = useAuthentication();
  const menuItems = canManageElevatedPermissions ? [...MENU_ITEMS, ELEVATED_USERS_MENU_ITEM] : MENU_ITEMS;

  const currentPath = window.location.pathname;
  const selected = menuItems.find(item => currentPath.includes(item.value))?.value || 'organizations';

  const history = useHistory();

  function handleNavigation(value) {
    const item = menuItems.find(item => item.value === value);
    if (item) {
      history.push(`/admin/${item.value}`);
    }
  }

  return (
    <Flex gap='4'>
      <Text
        size='6'
        weight='bold'
      >
        Admin
      </Text>
      <SegmentedControl.Root
        defaultValue={selected}
        onValueChange={handleNavigation}
      >
        {menuItems.map(item => (
          <SegmentedControl.Item
            key={item.value}
            value={item.value}
          >
            {item.label}
          </SegmentedControl.Item>
        ))}
      </SegmentedControl.Root>
    </Flex>
  );
}

export default Menu;
